import { Platform } from 'react-native';

export const iframePostMessage = (field: string, value: string | number | boolean | object) => {
  if (Platform.OS === 'web') {
    let jsonMessage = Object({});
    jsonMessage[field] = value;
    const message = JSON.stringify(jsonMessage);
    window.top?.postMessage(message, '*');
  }
};
